import PropTypes                 from 'prop-types'
import React                     from 'react'
import { connect               } from 'react-redux'
import { withRouter, matchPath } from 'react-router'
import { NavItem               } from 'react-bootstrap'

import { dispatchToProps                     } from 'alto-utils/lib/store'
import { NavLink                             } from 'alto-react-components/lib/components'
import { ClientAuthUserBar                   } from 'alto-react-client-auth/lib/components'
import { showOrderSummary, forgetCanteenData } from 'alto-react-canteen/lib/store'
import { menuSetting, GLOBAL                 } from 'alto-react-canteen/lib/settings'
import { CanteenProfileNavLink, menu         } from 'alto-react-canteen/lib/routes'

class CanteenUserBar extends ClientAuthUserBar.WrappedComponent
  @contextTypes: { auth: PropTypes.object, settings: PropTypes.object }

  constructor: (props, context) ->
    super(props, context)

    @confirmationStyle = menuSetting(context.settings).confirmation.style

  navLinks: ->
    <React.Fragment>
      <CanteenProfileNavLink />
      <NavItem id='logout-link' onClick={=> @logOut()}>Odhlásit</NavItem>
    </React.Fragment>

  logOut: (message, messageType) ->
    if (not @context.auth.isClient or
        not @props.menu or
        @confirmationStyle != GLOBAL or
        @props.menu.isSaved() or
        message == 'session_expired')
      super(message, messageType)
    else
      @props.showOrderSummary()
      @props.history.push(menu) unless matchPath(@props.history.location.pathname, path: menu)

  beforeLogOut: -> @props.forgetCanteenData()

mapStateToProps    = (state) -> _.pick(state.canteen, 'menu')
mapDispatchToProps = dispatchToProps({ showOrderSummary, forgetCanteenData })

export default CanteenUserBar = connect(mapStateToProps,
                                        mapDispatchToProps)(withRouter(CanteenUserBar))
